import consumer from "./consumer"

const MusicVideoChannel = {
  subscribe(videoConfigId, handlers = {}) {
    return consumer.subscriptions.create(
      {
        channel: "MusicVideoChannel",
        video_config_id: videoConfigId
      },
      {
        connected() {
          console.log(`[MusicVideoChannel] Connected to config ${videoConfigId}`)
          if (handlers.onConnected) handlers.onConnected()
        },

        disconnected() {
          console.log(`[MusicVideoChannel] Disconnected from config ${videoConfigId}`)
          if (handlers.onDisconnected) handlers.onDisconnected()
        },

        received(data) {
          console.log("[MusicVideoChannel] Update:", data)

          // Dispatch to type-specific handlers if provided.
          if (data.type && handlers[data.type]) {
            handlers[data.type](data)
          }

          // Also dispatch to status-based handlers (completed/failed).
          const status = data.status
          if (status === "completed" || status === "extended") {
            if (handlers.onCompleted) handlers.onCompleted(data)
          } else if (status === "failed" || status === "extend_failed") {
            if (handlers.onFailed) handlers.onFailed(data)
          } else if (status === "started" || status === "extending") {
            if (handlers.onStarted) handlers.onStarted(data)
          }

          // Generic fallback.
          if (handlers.onUpdate) handlers.onUpdate(data)
        }
      }
    )
  }
}

export default MusicVideoChannel
